import { useState } from 'react'
import AppModal from './AppModal'
import colors from '../../../constants/colors'
import AppRemixIcon from '../icon/AppRemixIcon'


export default function AppHelpModal(props) {
  const {
    children,
    size = 'md',
    iconClassName,
    title = 'Ayuda',
    customSelector,
    confirmBtnText = 'Entendido',
    ...others
  } = props
  const [show, setShow] = useState(false)

  return (
    <>
      <AppModal
        show={show}
        isConfirmBtn
        isCancelBtn={false}
        title={title}
        size={size}
        confirmBtnText={confirmBtnText}
        onClose={() => setShow(false)}
        onConfirm={() => setShow(false)}
        {...others}
      >
        {children}
      </AppModal>
      {!customSelector ? (
        <AppRemixIcon
          icon='question'
          onClick={() => setShow(true)}
          color={colors.primary}
          className={`pointer ${iconClassName}`}
        />
      ) : (
        <div style={{ display: 'inline-block' }} onClick={() => setShow(true)}>
          {customSelector}
        </div>
      )}
    </>
  )
}
